import botpic from "../assets/images/botpic_2.jpg";

const Bang = () => {
  return (
    <div className="flex items-center justify-center bg-top mobile:max-h-[40px] small:max-h-[54px] desktop:max-h-[79px] bg-bang mobile:bg-[length:270px_40px] small:bg-[length:300px_54px] desktop:bg-[length:438px_79px] mobile:h-[50px] small:h-12 desktop:h-20 bg-no-repeat gap-2">
      <div className="bang__botpic">
        <img
          src={botpic}
          alt="botpic"
          className="mobile:w-5 mobile:h-5 small:h-8 small:w-8 desktop:w-12 desktop:h-12 rounded-full"
        />
      </div>
      <div className="bang__botname">
        <p className="mobile:text-sm small:text-base desktop:text-3xl uppercase font-secondaryTitle bg-gradient-white bg-clip-text text-transparent">
          Sellboss Projects
        </p>
      </div>
    </div>
  );
};

export default Bang;
